module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('empty-reminder', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.records.length === 0 && !_vm.loading),
      expression: "records.length === 0 && !loading"
    }]
  }), _vm._v(" "), _c('div', _vm._l((_vm.records), function(record) {
    return _c('div', {
      staticClass: "records"
    }, [_c('p', {
      staticClass: "describe"
    }, [_vm._v(_vm._s(_vm.$t('user')) + _vm._s(record.nickname) + _vm._s(_vm.$t(record.status)))]), _vm._v(" "), _c('p', [_c('span', [_vm._v(_vm._s(_vm.$t('time')) + ": ")]), _vm._v(_vm._s(_vm._f("createFormatTime")(record.created_at, record.created_at)))])])
  }), 0), _vm._v(" "), _c('spinner', {
    staticClass: "spinner-component",
    attrs: {
      "show": _vm.loading
    }
  }), _vm._v(" "), _c('back-to-top'), _vm._v(" "), _c('load-more', {
    attrs: {
      "current-page": _vm.currentPage,
      "total-page": _vm.totalPage,
      "loading": _vm.loading
    },
    nativeOn: {
      "click": function($event) {
        return _vm.getRecords($event)
      }
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-3be30174!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/commission/friendRecords/FriendRecordsM.vue
// module id = 1301
// module chunks = 1